class CartUpsell extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('load', this.createSlider.bind(this));
  }

  createSlider() {
    const slides = document.querySelectorAll('.cart-upsell-slider .keen-slider__slide');
    
    if (slides.length < 1) {
      this.classList.add('hidden');
      return;
    } 
    
    let drag = false;
    const slider = new KeenSlider(".cart-upsell-slider", {
      dragChecked() {
        drag = true;
      },
      dragEnded() {
        setTimeout(() => (drag = false), 0);
      },
      created() {
        document.querySelector('.cart-upsell-slider').addEventListener("click", (e) => {
          if (drag) {
            e.stopPropagation();
            e.preventDefault();
          }
        })
      },
      slides: {
        perView: 1.25,
        spacing: 12
      }
    }, [navigation]);

    this.arrows();
  }

  arrows() {
    const upsellArrows = this.querySelectorAll('.cart-upsell__arrows .icon-arrow');
    upsellArrows.forEach(arrow => {
      arrow.addEventListener('click', this.onArrowClick);
    })
  }

  onArrowClick() {
    const relatedArrow = this.closest('.cart-upsell').querySelector(`.cart-upsell__body ${this.dataset.class}`);
    relatedArrow.click();
  }
}

customElements.define('cart-upsell', CartUpsell);